import { useCallback } from 'react';
import { useProductList } from '../context';
import useProduct from '@/lib/hooks/useProduct/project-builder';

const useRefinementHelpers = () => {
  const { categories } = useProduct();

  const { facetsConfiguration } = useProductList();

  const resolveLabel = useCallback(
    (attribute: string, label: string) => {
      if (attribute.match(/categoryId/))
        return (categories ?? []).find((category:any) => category.categoryId === label)?.name ?? '';

      if (facetsConfiguration[attribute]?.type === 'boolean') return facetsConfiguration[attribute].label;

      return label;
    },
    [categories, facetsConfiguration],
  );

  return { resolveLabel };
};

export default useRefinementHelpers;
